export const favoriteSessionsArray = [
  {
    title: 'Body / Muscle / Foot Worship',
    description: 'Adore every inch of My physique — from powerful muscles to delicate feet.',
    image: '/images/body-muscle-foot-worship.webp',
  },
  {
    title: 'JOI (Jerk Off Instruction)',
    description: 'Follow My exact commands, stroke by stroke, with no control of your own.',
    image: '/images/joi.webp',
  },
  {
    title: 'CEI / Humiliation / Degradation',
    description: 'I will break you down, humiliate you, and control every filthy moment.',
    image: '/images/cei-humiliation.webp',
  },
  {
    title: 'Chastity, Tease and Denial',
    description: 'Locked away and teased mercilessly — pleasure is never yours to claim.',
    image: '/images/chastity-tease.webp',
  },
  {
    title: 'Slave Training',
    description: 'Obedience, discipline, and devotion — molded into the perfect submissive.',
    image: '/images/slave-training.webp',
  },
  {
    title: 'Pegging / Strap-on Worship',
    description: 'Surrender your body for My pleasure and domination.',
    image: '/images/pegging.webp',
  },
];

export const offeringsArray = [
  { label: 'Armpit Worship (Clean)' },
  { label: 'Armpit Worship (Dirty)' },
  { label: 'Ballbusting' },
  { label: 'Bondage' },
  { label: 'Body Worship' },
  { label: 'CBT' },
  { label: 'CEI' },
  { label: 'Chastity' },
  { label: 'Denim' },
  { label: 'Degradation' },
  { label: 'Domestic Tasks / Domestic Slave' },
  { label: 'Edging' },
  { label: 'Encouraged Bi' },
  { label: 'Facesitting' },
  { label: 'Farts' },
  { label: 'Financial Domination' },
  { label: 'Foot Worship (Clean)' },
  { label: 'Foot Worship (Dirty)' },
  { label: 'Gags' },
  { label: 'Golden Shower' },
  { label: 'Gooning' },
  { label: 'Gym role play/spandex/leggings' },
  { label: 'Human Ashtray' },
  { label: 'Human Furniture' },
  { label: 'Humiliation (Light)' },
  { label: 'Humiliation (Heavy)' },
  { label: 'Ignoring' },
  { label: 'JOI' },
  { label: 'Leather' },
  { label: 'Mind fuck ' },
  { label: 'Muscle Domination ' },
  { label: 'Nipple Play' },
  { label: 'Oil' },
  { label: 'Orgasm control' },
  { label: 'Pantyhose/Fishnet Worship' },
  { label: 'Pet Play' },
  { label: 'Role play' },
  { label: 'Shopping Trips' },
  { label: 'Sensual Domination' },
  { label: 'Slave & Slut Training' },
  { label: 'Sneaker/Heel/Boot Worship' },
  { label: 'SPH' },
  { label: 'Spitting' },
  { label: 'Strap-On Worship/Pegging' },
  { label: 'Tease and Denial' },
  { label: 'Trampling' },
  { label: 'Wedgie' },
];


export const exclusionsArray = [
  { label: 'No scat.' },
  { label: 'No blood.' },
  { label: 'No needles.' },
  { label: 'No medical play.' },
  { label: 'No blackmail (BM).' },
  { label: 'No race play.' },
  { label: 'No CNC.' },
  { label: 'No sissification.' },
  { label: 'No intox.' },
];

